import { ReactNode, useContext } from "react";
import ChevronLeftRounded from "@mui/icons-material/ChevronLeftRounded";
import CloseRounded from "@mui/icons-material/CloseRounded";
import Typography from "../typography/Typography";
import { chevronLeftIcon } from "../../../constant";
import AppButton from "../button/button";
import IconButton from "../iconButton/IconButton";
import styles from "./headerNavTitle.module.scss";
import { iGlobalContext } from "../../../context/globalContext/interface";
import { StateContext } from "../../../context/globalContext/context";
import Discount from "../discount/discount";

interface HeaderNavTitleProps {
  onBackClick?: any;
  headerTitle?: string;
  showBack?: boolean;
  title?: ReactNode;
  leftIcon?: string;
  leftIconSize?: number;
  onLeftClick?: () => void;
  rightIcon?: string;
  rightIconSize?: number;
  onRightClick?: () => void;
  rightNode?: ReactNode;
  onBack?: () => void;
  onClose?: () => void;
  titleSize?: "size14" | "size16" | "size18";
  titleWeight?: 600 | 700;
  bare?: boolean;
}

export default function HeaderNavTitle({
  onBackClick,
  headerTitle = "History",
  showBack = true,
  title,
  leftIcon = chevronLeftIcon,
  leftIconSize = 20,
  onLeftClick,
  rightIcon,
  rightIconSize = 20,
  onRightClick,
  rightNode,
  onBack,
  onClose,
  titleSize,
  titleWeight = 600,
  bare = false,
}: HeaderNavTitleProps) {
  const { promoCode, isMobile }: iGlobalContext = useContext(StateContext);
  const resolvedTitle = title ?? headerTitle;
  const handleLeftClick = onLeftClick ?? onBackClick;
  const rightContent =
    rightNode ?? (onClose ? <IconButton icon={CloseRounded} label="Close" onClick={onClose} /> : null);

  const row = (
    <div className={`${styles.nav} ${rightContent ? styles.navRightNode : ""}`}>
      {onBack ? (
        <IconButton icon={ChevronLeftRounded} label="Back" onClick={onBack} />
      ) : showBack ? (
        <AppButton
          iconBtn={leftIcon}
          btnText=""
          onClick={handleLeftClick}
          iconHeight={leftIconSize}
          variant="transparent"
        />
      ) : (
        <div />
      )}
      <Typography size={titleSize ?? "size18"} variant="h1" weight={titleWeight} className={styles.heading}>
        {resolvedTitle}
      </Typography>
      {rightContent ? (
        <div className={styles.rightCell}>{rightContent}</div>
      ) : rightIcon ? (
        <AppButton
          iconBtn={rightIcon}
          btnText=""
          onClick={onRightClick}
          iconHeight={rightIconSize}
          variant="transparent"
        />
      ) : (
        <div />
      )}
    </div>
  );

  if (bare) return row;

  return (
    <div className={styles.stickyHeading}>
      {isMobile && (
        <div style={{ width: "100%" }}>
          {promoCode[0]?.description && <Discount promoCodeDescription={promoCode[0]?.description} />}
        </div>
      )}
      {row}
    </div>
  );
}
